<template>
    <div class="container-fluid">
        <div class="d-flex justify-content-end" style="border-bottom: 1px solid #282D69;">
            <button type="button" class="btn btn-add-alt mt-4" v-if="editEnabled" v-on:click="$emit('handleAddProperty')">ADD FIELD</button>
            <button type="button" class="btn btn-add mt-4 text-white" v-if="editEnabled" v-on:click="$emit('handlePreview')">PREVIEW</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CertificateActions",
        props: ["edit"],
        data() {
            return {
                editEnabled: this.edit,
            }
        },
        watch: {
            edit: function (newVal, oldVal) {
                this.editEnabled = newVal;
            }
        },
        mounted() {
            //console.log("Certificate actions loaded", this.edit);
        }
    }
</script>